/**
 * Insurance coverage configuration for Brasilia brand
 */
const brasiliaInsuranceCoverage = {
  coverageItems: [
    {
      key: 'traffic_accident_death',
    },
    {
      key: 'total_permanent_disability_traffic_accident',
    },
    {
      key: 'pet_death_assistance_traffic_accident',
    },
    {
      key: 'qualified_theft_baggage',
    },
    {
      key: 'protected_wallet_coverage',
    },
  ],
  disclaimerText: '',
};

export default brasiliaInsuranceCoverage;
